import { SupportedLocales } from "@bookingcom/lingojs-react";

export const SUPPORTED_LOCALES = [SupportedLocales["en-gb"]] as const;

export const DEFAULT_LOCALE = SupportedLocales["en-gb"] as const;
